var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tdesign:money"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 11.4585C10.1491 11.4585 9.333 11.7965 8.73133 12.3982C8.12965 12.9999 7.79163 13.8159 7.79163 14.6668C7.79163 15.5177 8.12965 16.3338 8.73133 16.9355C9.333 17.5371 10.1491 17.8752 11 17.8752C11.8509 17.8752 12.6669 17.5371 13.2686 16.9355C13.8703 16.3338 14.2083 15.5177 14.2083 14.6668C14.2083 13.8159 13.8703 12.9999 13.2686 12.3982C12.6669 11.7965 11.8509 11.4585 11 11.4585ZM9.62496 14.6668C9.62496 14.3022 9.76982 13.9524 10.0277 13.6946C10.2855 13.4367 10.6353 13.2918 11 13.2918C11.3646 13.2918 11.7144 13.4367 11.9722 13.6946C12.2301 13.9524 12.375 14.3022 12.375 14.6668C12.375 15.0315 12.2301 15.3812 11.9722 15.6391C11.7144 15.897 11.3646 16.0418 11 16.0418C10.6353 16.0418 10.2855 15.897 10.0277 15.6391C9.76982 15.3812 9.62496 15.0315 9.62496 14.6668Z",
    fill: "#504F4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.0655 4.68959L13.1514 0.604004L2.4365 9.16384L1.8425 9.15742V9.16659H1.375V20.1666H20.625V9.16659H19.7432L17.9887 4.03417L16.0655 4.68959ZM17.8062 9.16659H8.61392L15.4605 6.83275L16.8557 6.38634L17.8062 9.16659ZM14.2542 5.30742L7.18667 7.71642L12.7838 3.24492L14.2542 5.30742ZM3.20833 16.6548V12.6765C3.59507 12.5395 3.94635 12.3178 4.23655 12.0278C4.52676 11.7377 4.74858 11.3866 4.88583 10.9999H17.1142C17.2514 11.3867 17.4732 11.738 17.7634 12.0282C18.0536 12.3184 18.4049 12.5402 18.7917 12.6774V16.6558C18.4049 16.793 18.0536 17.0147 17.7634 17.3049C17.4732 17.5951 17.2514 17.9465 17.1142 18.3333H4.88767C4.75034 17.9461 4.5283 17.5945 4.23777 17.3042C3.94724 17.0138 3.59553 16.792 3.20833 16.6548Z",
    fill: "#504F4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/Money.e4ab34dccdb6ac75cc00db7d6bbb28cf.svg";
export { ForwardRef as ReactComponent };